/* eslint-disable import/prefer-default-export */
import { accountLookupUrl } from '../urls';
import refresh from '../refresh';

export async function getAccountLookupWithEmail(email) {
  const url = `${accountLookupUrl}?${new URLSearchParams({
    email,
  })}`;
  return refresh(async () => {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
